import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DRIVE } from 'documents-ui/constants/ImportTypes';
import openGoogleDrivePicker from 'documents-ui/lib/openGoogleDrivePicker';
import * as GoogleDriveActions from 'documents-ui/actions/GoogleDriveActions';
import GoogleConsentModal from './GoogleConsentModal';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import ButtonWithEditWarning from './ButtonWithEditWarning';
import { SocialGoogleDriveIcon } from 'foundations-assets/icons/components/SocialGoogleDriveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoogleDriveButton = ({
  isLoaded,
  googleAuthToken,
  useMultiSelect,
  getGoogleAuth,
  loadGoogleApi,
  importFile,
  editWarningConfig,
  onClick
}) => {
  const [showConsentModal, setShowConsentModal] = useState(false);
  useEffect(() => {
    if (!isLoaded) {
      loadGoogleApi();
    }
  });
  const handleGoogleFileSelect = file => {
    importFile({
      file,
      type: DRIVE
    });
  };
  const handleClick = () => {
    const googleAuthConfig = {
      useMultiSelect,
      onSelect: handleGoogleFileSelect
    };
    if (!googleAuthToken) {
      setShowConsentModal(true);
    } else {
      openGoogleDrivePicker(Object.assign({}, googleAuthConfig, {
        authToken: googleAuthToken
      }));
      onClick();
    }
  };
  const handleOnAccept = () => {
    const googleAuthConfig = {
      useMultiSelect,
      onSelect: handleGoogleFileSelect
    };
    getGoogleAuth(googleAuthConfig).then(authToken => {
      openGoogleDrivePicker(Object.assign({}, googleAuthConfig, {
        authToken
      }));
    }).catch(() => {
      addAlert('getGoogleAuth', 'danger', {});
    });
    onClick();
  };
  const handleOnCancel = () => {
    setShowConsentModal(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonWithEditWarning, Object.assign({}, editWarningConfig, {
      onClick: handleClick,
      disabled: !isLoaded,
      icon: SocialGoogleDriveIcon,
      children: "Google Drive"
    })), showConsentModal && /*#__PURE__*/_jsx(GoogleConsentModal, {
      onConfirm: handleOnAccept,
      onCancel: handleOnCancel
    })]
  });
};
export default connect(({
  googleDrive
}) => ({
  isLoaded: googleDrive.isLoaded,
  googleAuthToken: googleDrive.googleAuthToken
}), Object.assign({}, GoogleDriveActions))(GoogleDriveButton);